<template style="">
  <div class="Picture_release" v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-form label-width="150px" style="padding-top: 20px;">
      <el-form-item label="公告标题" :rules="[{ required: true, message: '请输入公告标题', trigger: 'blur' }]">
        <el-input style="width: 300px;" v-model="MaterialName" placeholder="请输入公告标题（5-30个汉字）"></el-input>
      </el-form-item>

      <el-form-item label="上传封面" :rules="[{ required: true, message: '请上传封面', trigger: 'blur' }]" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：2.35:1</p>
      </el-form-item>

      <el-form-item label="图片应用到轮播图">
        <el-switch v-model="AppHomepage"></el-switch> 
      </el-form-item>

      <el-form-item label="语言" :rules="[{ required: true, message: '请选择语言', trigger: 'blur' }]">
        <el-radio-group v-model="RotatLanguage">
          <el-radio label="1">中</el-radio>
          <el-radio label="2">英</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="相关附件上传" prop="region">
        <el-upload :on-remove="handleRemove" action="" accept="" :auto-upload="false" :on-change="handleChanges" multiple :file-list="fileList2">
          <el-button class="video_btn iconfont icontianjia3">上传附件</el-button>
        </el-upload>
      </el-form-item>

      <!-- <el-form-item label="栏目">
        <el-cascader ref="wcascader" v-model="ItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择上级栏目"></el-cascader>
      </el-form-item>
  
      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="item in tagList" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->

      <el-form-item label="定时发送">
        <el-radio-group v-model="timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="timisngs == '2'" label="定时时间">
        <el-date-picker  v-model="ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange">
          </el-date-picker>
      </el-form-item>

      <el-form-item label="用途">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="Purpose"></el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input :rows="2" placeholder="请输入内容" v-model="LineNumber"></el-input>
      </el-form-item>

      <!-- <el-form-item label="是否启用">
        <el-switch v-model="isActive" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item> -->

      <!-- <el-form-item label="版权声明">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" maxlength="200" v-model="CopyrightStatement"></el-input>
      </el-form-item> -->

      <el-form-item label="内容" :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]" class="ue">
        <div class="editor-container">
          <UEtext :defaultMsg=defaultMsg ref="ue"></UEtext>
        </div>
      </el-form-item>


      <el-form-item label="审核意见" v-if="state==1">
        <el-radio-group v-model="AuditStatus">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="AuditStatus==2 && state==1" label="驳回原因">
        <el-input type="textarea" v-model="ReasonRejection" :autosize="{ minRows: 2}"></el-input>
      </el-form-item>
      <el-form-item style="padding-bottom: 30px;" v-if="state==1">
        <el-button type="primary"  @click="onSubmit(1)">保存</el-button>
      </el-form-item>
      <el-form-item style="padding-bottom: 30px;" v-else>
        <el-button type="primary" @click="onSubmit(1)">{{materialKey?'立即修改':'立即创建'}}</el-button>
        <!-- <el-button type="primary"  v-if="!materialKey" @click="onSubmit(2)">保存草稿</el-button> -->
      </el-form-item>
      
    </el-form>

    <el-dialog title="图片裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>
<script>
import UEtext from '@/components/text.vue';
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: { UEtext,PictureCropper},
  data() {

    return {
      RotatLanguage:'',
      AppHomepage:true,
      fileList2: [],
      ruleFormfiles: [],
      Purpose: '',
      LineNumber: '',
      isActive: '',
      CopyrightStatement: '',
      data: [],
      loading:false,
      videopd:false,
      videourl: '',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      MaterialName: "",//视频标题
      Label: [],//标签
      ItemKey: "",//栏目
      img: "",
      imageUrl: '',
      tagList:[],//标签列表
      columnList: [],//栏目列表
      defaultMsg: '',
      timisngs:'', 
      ScheduledRelease:'',
      materialKey: '',
      isActive:1,
      state:0,

      // 裁剪
      Croppdialog:false,
      previews: {},
      cropperHeight: '600px',  // 裁剪图片容器高度
      cropperWidth: '600px',   // 裁剪图片容器宽度
      autoCropWidth: 200,
      autoCropHeight: 200,
      
      state:0,
      AuditStatus:'',
      ReasonRejection:'',
    }
  },
  // ==== 新增计算属性 ====
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  mounted() {
    this.$Http_Post('management/tagList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.tagList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/columnList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.columnList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    });
    this.materialKey = this.$route.query.materialKey; 
    if(this.materialKey){
      this.state=this.$route.query.type;
      this.getContentDetails();
      }
  },
  methods: {     
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ScheduledRelease || this.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      }
      
      try {
        const selectedDate = new Date(this.ScheduledRelease);
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ScheduledRelease = adjustedDate;
        }
      }
    },
    getContentDetails(){
      this.$Http_Post('management/getContentDetails', { MaterialKey: [this.$route.query.materialKey][0] }).then((res) => {         
        if (res.Code == 200 || res.Code == 0) { 
          this.MaterialName = res.Data.materialName
          this.imageUrl = res.Data.materialCover
          this.imageFile=res.Data.materialCover
          this.AppHomepage = res.Data.appHomepage==1?true:false
          this.delivery = res.Data.isActive==1?true:false
          this.RotatLanguage = res.Data.rotatLanguage
          this.Purpose = res.Data.purpose
          this.LineNumber = res.Data.lineNumber
          this.CopyrightStatement = res.Data.copyrightStatement
          this.defaultMsg = res.Data.richTextContent;
          //this.fileList2=res.Data.materialPaths.map((item)=>{name:item});
          this.ScheduledRelease=res.Data.ScheduledRelease;
          // 新增判断逻辑
          if (res.Data.ScheduledRelease) {
              this.timisngs = "2";
          } else {this.timisngs = "1";}
          for(var i = 0;i<res.Data.materialPaths.length;i++){
            this.fileList2.push(
              {
                name:res.Data.materialPaths[i]
              }
            )
          }

        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    picturePreview(data){
      this.previews = data
    },
    Selected_to_shut_dow(dt) {
      this.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    async download(){
      let aLink = document.createElement('a')
      aLink.download = '下载裁剪图片'
      let data = await this.$refs.picture.getBase64()
      aLink.href = data
      aLink.click()
    },

    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {

      let obj = this.data[0];

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
      
    },

    handleRemove(file, fileList) {
      this.ruleFormfiles = [];
      this.fileList2 = fileList
      if (fileList.length >= 2) {
        for (var i = 0; i < fileList.length; i++) {
          this.ruleFormfiles.push(fileList[i].raw);
        }

      } else {
        this.ruleFormfiles.push(fileList[0].raw);
      }
    },
    handleChanges(file, fileList) {
      if (fileList.length >= 2) {
        this.ruleFormfiles = [];
        for (var i = 0; i < fileList.length; i++) {
        this.ruleFormfiles.push(fileList[i].raw);
        }
      } else {
        this.ruleFormfiles.push(fileList[0].raw);
      }
    },

    onSubmit(type) {//创建 
      if(!this.MaterialName){
        alert('请输入公告标题');
        return false;
      }
      if(!this.RotatLanguage){
        alert('请选择语言');
        return false;
      }
      // 单独检查封面
      if (!this.imageFile && !this.imageUrl) {
          this.$message.error('请选择上传封面');
          return false;
      }
        // 验证 UEditor 内容
      let ueContent = '';
      try {
        // 获取 UEditor 内容
        ueContent = this.$refs.ue.getUEContent();
        
        // 检查内容是否为空
        if (!ueContent || ueContent.trim() === '') {
          this.$message.error('请输入内容');
          return false;
        }
        
        // 去除HTML标签后检查是否有实际内容
        const textContent = ueContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
        if (textContent === '') {
          this.$message.error('请输入有效的内容');
          return false;
        }
          // 检查内容长度（可选）
        if (textContent.length < 10) {
          this.$message.error('内容太短，请至少输入10个有效字符');
          return false;
        }
        
      } catch (error) {
        console.error('获取编辑器内容失败:', error);
        this.$message.error('获取编辑器内容失败，请重试');
        return false;
      }
      this.loading = true;
      var from = new FormData();
      if(this.materialKey){//修改
        from.append('MaterialKey', this.materialKey);
        from.append('RoleID',sessionStorage.getItem('RoleID'));
      }
      from.append('fileName', this.imageFile==""?"":this.imageFile);
      from.append('MaterialName', this.MaterialName);
      from.append('Label', this.Label);
      from.append('ItemKey', this.ItemKey);
      from.append('Type', type);
      from.append('Purpose', this.Purpose);
      from.append('LineNumber', this.LineNumber);      
      from.append('IsActive', this.isActive);
      from.append('CopyrightStatement', this.CopyrightStatement);
      from.append('CodeSnippet',this.$refs.ue.getUEContent());
      from.append('RotatLanguage', this.RotatLanguage);
      from.append('AppHomepage', this.AppHomepage ==true?'1':'0');
      from.append('ScheduledRelease',this.ScheduledRelease)
      for(var i = 0; i<this.ruleFormfiles.length;i++){
        from.append('annexFile', this.ruleFormfiles[i]);
      }
      if(this.state==1){
        from.append('AuditStatus', this.AuditStatus);
        if(this.AuditStatus==2){
          from.append('ReasonRejection', this.ReasonRejection);
        }
      }
      this.$Http_Post('management/NoticePublishing', from, { 'Content-Type': 'multipart/form-data', }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.videopd = true;
          this.loading = false;
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/propagate/index',
          })
        } else {
          this.loading = false;
          this.Global.request_failure(res.Message);
        }
      })

    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imageFile = file;
        this.Croppdialog=true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    videohandleChange(file, fileList) {
      if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        this.videoFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
      }
    },
    videohandleAvatarSuccess(res, file) {},
    videobeforeAvatarUpload(file) {},
    //进度条
    uploadVideoProcess(event, file, fileList) {},
  },
}
</script>
<style>
  .Picture_release{background-color: #fff;width: 100%;}
  .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
  .Picture_release .el-textarea{width: 400px !important;}
  .Picture_release .el-input{width: 400px !important;}
  .editor-container{width: 750px;display: block;}
  .ue .el-form-item__content{line-height:1;}
  
</style>
